/* eslint-disable sort-keys */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const SEO = ({
  description = '',
  lang = 'en',
  meta = [],
  keywords = [],
  title
}) => (
  <Helmet
    defaultTitle="Salata"
    htmlAttributes={{ lang }}
    title={title}
    titleTemplate="%s | Salata - Salad Bar"
    meta={[
      {
        charset: 'utf-8'
      },
      {
        content: 'IE=edge',
        httpEquiv: 'X-UA-Compatible'
      },
      {
        content: 'yes',
        name: 'apple-mobile-web-app-capable'
      },
      {
        content: description,
        name: 'description'
      },
      {
        content: title,
        property: 'og:title'
      },
      {
        content: description,
        property: 'og:description'
      },
      {
        content: 'website',
        property: 'og:type'
      },
      {
        content: 'summary',
        name: 'twitter:card'
      },
      {
        content: 'Salata - The Next Generation Salad Bar',
        name: 'twitter:creator'
      },
      {
        content: title,
        name: 'twitter:title'
      },
      {
        content: description,
        name: 'twitter:description'
      },
      {
        content:
          'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0',
        name: 'viewport'
      }
    ]
      .concat(
        keywords.length > 0
          ? {
            content: keywords.join(`, `),
            name: 'keywords'
          }
          : []
      )
      .concat(meta)}
    link={[{ href: '/images/favicon.ico', rel: 'icon', type: 'image/png' }]}

    script={[
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          'image': [
            'https://webapi.salata.com/wp-content/uploads/2024/01/Salata-Home-Banner-2-1200-x-876-px.png'
          ],
          'name': 'Salata',
          'address': {
            '@type': 'PostalAddress',
            'streetAddress': '16720 Park Row Dr',
            'addressLocality': 'Houston',
            'addressRegion': 'TX',
            'postalCode': '77084',
            'addressCountry': 'United States'
          },
          'url': 'https://www.salata.com/',
          'telephone': '+18447252821',
          'priceRange': '$$$'
        })
      }      
    ]}
  />
);

SEO.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string
};

export default SEO;
